import { createFileRoute } from "@tanstack/react-router";
import Marcas from "@/pages/Marcas";
import { supabase } from "@/integrations/supabase/client";
import { seoHead } from "@/lib/seoHead";

interface CategorySeo {
  name?: string | null;
  slug?: string | null;
  seo_title?: string | null;
  seo_description?: string | null;
}

export const Route = createFileRoute("/marcas/$categorySlug")({
  loader: async ({ params }) => {
    try {
      const { data } = await supabase
        .from("categories")
        .select("name, slug, seo_title, seo_description")
        .eq("slug", params.categorySlug)
        .maybeSingle();
      return { category: (data ?? null) as CategorySeo | null };
    } catch {
      return { category: null };
    }
  },
  // Mesmos valores do usePageSeo da página, agora renderizados no servidor.
  head: ({ loaderData, params }) => {
    const cat = loaderData?.category;
    if (!cat?.name) {
      return seoHead({
        title: "Marcas Parceiras | Shopping do Bem",
        description:
          "Conheça as +300 marcas parceiras do Shopping do Bem. Compre e doe sem custo extra.",
        path: `/marcas/${params.categorySlug}`,
      });
    }
    return seoHead({
      title: cat.seo_title || `Cupons de ${cat.name} | Lojas Parceiras do Shopping do Bem`,
      description:
        cat.seo_description ||
        `Cupons, ofertas e descontos nas lojas de ${cat.name}. Compre nas suas lojas favoritas e parte do valor vira doação, sem custo extra.`,
      path: `/marcas/${cat.slug || params.categorySlug}`,
    });
  },
  component: Marcas,
});
